/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import StatCard from "../../../../../SharedComponent/Dashboard/StatCard";
import { FaEdit, FaEye, FaPlus, FaTrash, FaChartLine , FaRegCopyright} from "react-icons/fa";
import Button from "../../../../../SharedComponent/Button/Button";
import style from "./../AssetManagerDashboard.module.css";
import { useTranslation } from "react-i18next";
import Pagination from "../../../../../SharedComponent/Pagination";
import { Navbar, Nav,Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios' ;
import {
  selectCustomerData,
  setAllCustomer,
} from "../../../../../redux/slices/customerSlice";
import CreateCustomerPage from "../../../../../components/common/CreateCustomerPage";
import UpdateCustomerPage from "../../../../../components/common/UpdateCustomerPage";
import { toast } from "react-toastify";
import { objectToQueryParams } from "../../../../../utils/commonHelper";
import { API_END_POINTS } from "../../../../../network/apiEndPoint";
import { getProtected, deleteProtected } from "../../../../../network/ApiService";
import Loading from "../../../../../SharedComponent/Loading";
import useDebounce from "../../../../../hooks/useDebounce";
import ViewCustomer from "../../../../../components/common/ViewCustomer";
import UpdateCustomerModal from "../../../../../components/common/UpdateCustomerModal";
import ViewSales from '../../../../../components/common/ViewSales';
import { getLanguage } from "../../../../../redux/slices/languageSlice";
import { useNavigate } from "react-router-dom";
import HeroSection from "../../../../../components/HeroSection/HeroSection";
import { baseURlNoAPI } from "../../../../../network/baseUrl";
import { useAppContext } from "../../../context/context";

const limit = 5;

// Dummy data
const dummyCustomers = [
  {
    id: 1,
    company_name: "Dummy GmbH",
    company_registration_number: "HRB 000000",
    vat_registration_number: "DE000000000",
    managing_director: "John Doe",
    homepage: "https://www.dummy.com",

    street_address_1: "Dummystraße 1",
    street_address_2: "Gebäude A, 1. Stock",
    zip_code: "00000",
    city: "Dummystadt",
    country: "Dummania",

    phone_number: "+49 00 00000000",
    email: "dummy@example.com",
    invoice_email: "invoice@dummy.com",

    contact_first_name: "Jane",
    contact_last_name: "Doe",
    contact_phone_number: "+49 151 00000000",
    contact_email: "jane.doe@example.com",

    company_logo_url: "https://zkzdqldpzvjeftxbzgvh.supabase.co/storage/v1/object/public/profile-images/uploads/0.03966602799335983.jpeg",
    contact_image_url: "https://zkzdqldpzvjeftxbzgvh.supabase.co/storage/v1/object/public/profile-images/uploads/0.03966602799335983.jpeg"
  },
  {
    id: 2,
    company_name: "Test AG",
    company_registration_number: "HRB 999999",
    vat_registration_number: "DE999999999",
    managing_director: "Alice Tester",
    homepage: "https://www.test.org",

    street_address_1: "Teststraße 42",
    street_address_2: "Etage 3",
    zip_code: "99999",
    city: "Teststadt",
    country: "Testland",

    phone_number: "+49 99 99999999",
    email: "test@example.org",
    invoice_email: "invoice@test.org",

    contact_first_name: "Bob",
    contact_last_name: "Tester",
    contact_phone_number: "+49 160 99999999",
    contact_email: "bob.tester@example.org",

    company_logo_url: "https://test.org/logo.svg",
    contact_image_url: "https://test.org/contact.jpg"
  },
  {
    id: 3,
    company_name: "Mock Industries",
    company_registration_number: "HRB 333333",
    vat_registration_number: "DE333333333",
    managing_director: "Carl Mockman",
    homepage: "https://www.mockindustries.com",

    street_address_1: "Mockweg 10",
    street_address_2: "Halle 2",
    zip_code: "33333",
    city: "Mockstadt",
    country: "Mockland",

    phone_number: "+49 33 33333333",
    email: "info@mockindustries.com",
    invoice_email: "billing@mockindustries.com",

    contact_first_name: "Clara",
    contact_last_name: "Mock",
    contact_phone_number: "+49 170 3333333",
    contact_email: "clara.mock@mockindustries.com",

    company_logo_url: "https://mock.com/logo.png",
    contact_image_url: "https://mock.com/contact.webp"
  },
  {
    id: 4,
    company_name: "Sample Solutions",
    company_registration_number: "HRB 444444",
    vat_registration_number: "DE444444444",
    managing_director: "Sam Sample",
    homepage: "https://www.samplesolutions.com",

    street_address_1: "Beispielallee 7",
    street_address_2: "Büro 5A",
    zip_code: "44444",
    city: "Sampleburg",
    country: "Samplestan",

    phone_number: "+49 44 44444444",
    email: "contact@samplesolutions.com",
    invoice_email: "invoice@samplesolutions.com",

    contact_first_name: "Sandra",
    contact_last_name: "Sampleson",
    contact_phone_number: "+49 172 4444444",
    contact_email: "sandra.sampleson@samplesolutions.com",

    company_logo_url: "https://sample.com/logo.jpg",
    contact_image_url: "https://sample.com/contact.png"
  },
  {
    id: 5,
    company_name: "Placeholder Partners",
    company_registration_number: "HRB 555555",
    vat_registration_number: "DE555555555",
    managing_director: "Peter Placeholder",
    homepage: "https://www.placeholder.com",

    street_address_1: "Hauptstraße 99",
    street_address_2: "Suite 12",
    zip_code: "55555",
    city: "Platzstadt",
    country: "Placeholderia",

    phone_number: "+49 55 55555555",
    email: "office@placeholder.com",
    invoice_email: "finance@placeholder.com",

    contact_first_name: "Paula",
    contact_last_name: "Holder",
    contact_phone_number: "+49 175 5555555",
    contact_email: "paula.holder@placeholder.com",

    company_logo_url: "https://placeholder.com/logo.svg",
    contact_image_url: "https://placeholder.com/contact.jpg"
  }
];


const Customers = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState({ status: "" });
  const [currentPage, setCurrentPage] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const { allCustomer, totalCustomer } = useSelector(selectCustomerData);
  const [viewCustomerId, setViewCustomerId] = useState(null);
  const [editCustomer, setEditCustomer] = useState(null);
  const [loader, setLoader] = useState(null);
  const [showSalesModal, setShowSalesModal] = useState(false);
  const { currentLanguages } = useSelector(getLanguage);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const navigate = useNavigate();
  const [showLoader , setShowLoader] = useState(false) ;
  const {searchQuery , setSearchQuery} = useAppContext() ; 

  const [customerInfo , setCustomerInfo] = useState([]) ; 

  const handleSearch = () => {
    console.log("Searching for:", searchQuery);
    setCurrentPage(1);
  };
  
  const debouncedQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    
    if (debouncedQuery !== undefined || debouncedQuery !== null) {
      setCurrentPage((pre) => 0);
      // Using dummy data instead of API call
      const filtered = customerInfo.filter(customer =>
        customer.company_name.toLowerCase().includes(debouncedQuery.toLowerCase()) ||
        customer.email.toLowerCase().includes(debouncedQuery.toLowerCase()) ||
        customer.managing_director.toLowerCase().includes(debouncedQuery.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, [debouncedQuery]);

  useEffect(() => {
    // Initialize with dummy data
    setFilteredCustomers(customerInfo);
  }, [currentPage, filters.status, currentLanguages]);

  useEffect(() => {
    const filtered = customerInfo.filter(customer =>
      customer.company_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      customer.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      customer.managing_director.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredCustomers(filtered);
  }, [searchQuery]);

  // Fetch customers data (modified to use dummy data)
  

  const fetchCustomers = async (e) => {
    setShowLoader(true); 
    
    try {
      const url = API_END_POINTS.customers;
      if (!url) {
        throw new Error("API endpoint not defined");
      }
     
      const response = await getProtected(url);

      if (response?.results && Array.isArray(response?.results) ) {
        console.log("response = " , response.results) ; 
        setCustomerInfo(response.results) ;
        setFilteredCustomers(response?.results)  ; 
      
        
      }
    } catch (error) {
      console.error("Create customer error:", error);
      const message = error?.response?.data?.messages?.[0]?.message;
      toast.error(t("dashboardToasters.genricError"));
    }
    finally{
      setShowLoader(false) ; 
    }
  };

  useEffect(() => {
    setSearchQuery("")
    fetchCustomers() ; 
  } , [] ) ;

  const handleDeleteCustomer = async (customer) => {
    setShowLoader(true) ;
    console.log("customer = " , customer) ;
    const {id} = customer; 
    const token = localStorage.getItem("access");
    if(!id) return ; 
    const url = `${API_END_POINTS.customers}`; 
    try {
      setLoader(true);
       await axios.delete(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          customer_id : id,
        },
      });
      const updatedCustomers = filteredCustomers.filter(c => c.id !== customer.id);
      setFilteredCustomers(updatedCustomers);
      toast.success(t("assets.messages.deleteSuccess"));
    } catch (e) {
      console.error(e);
      toast.error(t("assets.messages.deleteError"));
    } finally {
      setShowLoader(false ) ;
    }
  };

  if (showLoader) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
        <div className="text-center px-4 w-full max-w-sm">
          <div className="mx-auto h-12 w-12 sm:h-14 sm:w-14 mb-4 sm:mb-6">
            <div className="animate-spin h-full w-full border-4 sm:border-8 border-gray-200 border-t-blue-500 rounded-full"></div>
          </div>
          <div className="text-white text-lg sm:text-xl font-medium break-words">
            {/* {t("detailViewModel.loadingDetailView")} */}
            {t("createCustomerDashboard.loadingCustomerManagerDashboard")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-full flex flex-col min-h-screen bg-gray-50">
      <HeroSection t={t} showText={false}  />
      {/* <Loading loading={loader} text={t("common.loading.data")} /> */}

      <div className="w-full bg-white p-4 flex flex-col md:flex-row md:items-center justify-between ">
        
        <div className="mb-4 md:mb-0">
          <h1 className="text-xl md:text-2xl font-semibold">{t("createAsset.buttons.YourTickets")}</h1>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button 
            onClick={() => setShowSalesModal(true)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 flex items-center justify-center"
          >
            <FaChartLine className="mr-2" /> {t("common.salesReport")}
          </Button>
          <Button 
            onClick={() => navigate("/create-customer")}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 flex items-center justify-center"
          >
            <FaPlus className="mr-2" /> {t("customers.actions.create")}
          </Button>
        </div>
      </div>

      {/* Search Bar */}
      

      {/* Responsive Customer Table */}
      <div className="w-full px-4">
        {/* Mobile View (cards) - Show on small screens, hide on medium and up */}
        <div className="lg:hidden">
          {filteredCustomers.map((customer) => (
            <div key={customer.id} className="bg-white rounded-lg shadow-md p-4 mb-4">
              <div className="flex justify-between items-center mb-3">
                <div className="flex items-center space-x-3">
                  {customer.company_logo_url && (
                    <img 
                      src={baseURlNoAPI + customer.company_logo_url} 
                      // ${baseURlNoAPI}` + item.image
                      alt="Company Logo" 
                      className="w-8 h-8 object-contain"
                      onError={(e) => {e.target.style.display = 'none'}}
                    />
                  )}
                  <span className="font-medium text-gray-800">{customer.company_name}</span>
                </div>
                <span className="text-sm text-gray-500">ID: {customer.id}</span>
              </div>
              
              <div className="space-y-2 mb-3">
                <div className="grid grid-cols-1 gap-2">
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.companyRegistrationNumber")} :</span>
                    <span className="text-sm ml-2">{customer.company_registration_number}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.vatRegistrationNumber")} :</span>
                    <span className="text-sm ml-2">{customer.vat_registration_number}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.managingDirector")} :</span>
                    <span className="text-sm ml-2">{customer.managing_director}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.address")} :</span>
                    <span className="text-sm ml-2">{customer.street_address_1}, {customer.city}, {customer.country}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.phone")} :</span>
                    <span className="text-sm ml-2">{customer.phone_number}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.email")} :</span>
                    <span className="text-sm ml-2">{customer.email}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.contact")} :</span>
                    <span className="text-sm ml-2">{customer.contact_first_name} {customer.contact_last_name}</span>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500 font-medium">{t("createCustomerDashboard.homepage")} :</span>
                    <a href={customer?.homepage} target="_blank" rel="noopener noreferrer" className="text-sm ml-2 text-blue-600 hover:underline">
                      {customer?.homepage}
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="flex justify-end space-x-2 pt-2 border-t border-gray-200">
                <button
                  className="p-2 text-blue-600 hover:bg-blue-50 rounded-full"
                  onClick={() => setViewCustomerId(customer)}
                  title="View"
                >
                  <FaEye className="w-4 h-4" />
                </button>
                <button
                  className="p-2 text-green-600 hover:bg-green-50 rounded-full"
                  onClick={() => {
                    navigate(`/update-customer/${customer.id}`);
                  }}
                  title="Edit"
                >
                  <FaEdit className="w-4 h-4" />
                </button>
                <button
                  className="p-2 text-red-600 hover:bg-red-50 rounded-full"
                  onClick={() => handleDeleteCustomer(customer)}
                  title="Delete"
                >
                  <FaTrash className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Desktop View (table) - Hide on small screens, show on large and up */}
        <div className="hidden lg:block w-full overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.id")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.logo")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[120px]">{t("createCustomerDashboard.companyName")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.companyRegistrationNumber")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.vatRegistrationNumber")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[120px]">{t("createCustomerDashboard.managingDirector")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[150px]">{t("createCustomerDashboard.address")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.phone")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[150px]">{t("createCustomerDashboard.email")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[120px]">{t("createCustomerDashboard.contactPersonPlaceholder")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.contactPhone")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[120px]">{t("createCustomerDashboard.contactEmail")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="min-w-[120px]">{t("createCustomerDashboard.homepage")}</div>
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="whitespace-nowrap">{t("createCustomerDashboard.actions")}</div>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredCustomers.map((customer) => (
                <tr key={customer.id} className="hover:bg-gray-50">
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{customer.id}</td>
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                    {customer.company_logo_url && (
                      <img 
                    
                        src={baseURlNoAPI + customer.company_logo_url} 
                        alt="Company Logo" 
                        className="w-8 h-8 object-contain"
                        // onError={(e) => {e.target.style.display = 'none'}}
                      />
                    )}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-500 font-medium">{customer.company_name}</td>
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{customer.company_registration_number}</td>
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{customer.vat_registration_number}</td>
                  <td className="px-3 py-3 text-sm text-gray-500">{customer.managing_director}</td>
                  <td className="px-3 py-3 text-sm text-gray-500">
                    <div className="max-w-[150px]">
                      {customer.street_address_1}{customer.street_address_2 && `, ${customer.street_address_2}`}<br/>
                      {customer.zip_code} {customer.city}<br/>
                      {customer.country}
                    </div>
                  </td>
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{customer.phone_number}</td>
                  <td className="px-3 py-3 text-sm text-gray-500">
                    <a href={`mailto:${customer.email}`} className="text-blue-600 hover:underline">
                      {customer.email}
                    </a>
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-500">
                    <div>
                      {customer.contact_first_name} {customer.contact_last_name}<br/>
                      <a href={`mailto:${customer.contact_email}`} className="text-blue-600 hover:underline text-xs">
                        {customer.contact_email}
                      </a>
                    </div>
                  </td>
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{customer.contact_phone_number}</td>
                  <td className="px-3 py-3 text-sm text-gray-500">
                    <a href={`mailto:${customer?.contact_email || ""}`} className="text-blue-600 hover:underline">
                      {customer?.contact_email || ""}
                    </a>
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-500">
                    <a href={customer?.homepage} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      {customer?.homepage?.replace('https://www.', '').replace('https://', '')}
                    </a>
                  </td>
                  <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
                    <div className="flex space-x-2">
                      <button
                        className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-100 transition-colors"
                        onClick={() => setViewCustomerId(customer)}
                        title="View"
                      >
                        <FaEye className="w-4 h-4" />
                      </button>
                      <button
                        className="text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-100 transition-colors"
                        onClick={() => {
                          navigate(`/update-customer/${customer.id}`);
                        }}
                        title="Edit"
                      >
                        <FaEdit className="w-4 h-4" />
                      </button>
                      <button
                        className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-100 transition-colors"
                        onClick={() => handleDeleteCustomer(customer)}
                        title="Delete"
                      >
                        <FaTrash className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Pagination - visible on all screen sizes */}
        <div className="flex justify-center my-4 w-full">
          <Pagination
            totalItems={filteredCustomers.length}
            setItemOffset={setCurrentPage}
            itemOffset={currentPage}
            limit={limit}
          />
        </div>
      </div>
      

      {viewCustomerId && (
      <ViewCustomer
          id={viewCustomerId}
          setViewCustomerId={setViewCustomerId}
          t={t}
        />
      )}
      {editCustomer && (
        <UpdateCustomerPage
          editCustomer={editCustomer}
          onClose={setEditCustomer}
        />
      )}
      {showSalesModal && (
        <ViewSales 
          showModal={showSalesModal} 
          setShowModal={setShowSalesModal}
        />
      )}
    </div>
  );
};

export default Customers;